import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import Switch from '@/components/DSE/Switch';
import { validatorRequire } from '@/utils/validators';
import InputNumber from '@/components/DSE/InputNumber';

export function getFormDefinition(vue) {
  return {
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64
      },
      rules: [{ validator: validatorRequire }]
    },
    code: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 16
      },
      rules: [{ validator: validatorRequire }]
    },
    headingHeight: {
      type: MDinput,
      defaultValue: undefined,
      dynamicProps: form => {
        return {
          visible: vue.isHeadingHeightRequired()
        };
      },
      props: {
        type: 'number',
        precision: 1,
        caption: 'finish.headingHeight'
      }
    },
    printOnTicketYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'product.printOnTicket',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    hideQuantityOnTicketYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'finish.hideQuantityOnTicket',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    canBeExcludedDueToFabricYN: {
      type: Switch,
      defaultValue: false,
      props: {
        activeText: 'common.yes',
        inactiveText: 'common.no',
        caption: 'finish.canBeExcludedDueToFabricYN'
      }
    },
    canBeExcludedDueToWorkshopYN: {
      type: Switch,
      defaultValue: false,
      props: {
        activeText: 'common.yes',
        inactiveText: 'common.no',
        caption: 'finish.canBeExcludedDueToWorkshopYN'
      }
    },
    separateSeriesYN: {
      type: Switch,
      defaultValue: false,
      props: {
        activeText: 'common.yes',
        inactiveText: 'common.no',
        caption: 'finish.seperateSeriesYN'
      }
    },
    inactiveYN: {
      type: Switch,
      defaultValue: false,
      props: {
        activeText: 'common.yes',
        inactiveText: 'common.no',
        caption: 'common.inactive'
      }
    },
    quantityFormula: {
      type: MDinput,
      defaultValue: null,
      dynamicProps: (form, comp) => ({
        visible: vue.showQuantityFormula()
      }),
      props: {
        maxlength: 255,
        caption: 'finish.quantityFormula'
      }
    },
    roundOption: {
      type: Select,
      defaultValue: null,
      dynamicProps: (form, comp) => ({
        visible: vue.showRoundOption()
      }),
      props: {
        caption: 'finish.roundOption',
        required: true,
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('round')
      }
    },
    parityOption: {
      type: Select,
      defaultValue: null,
      dynamicProps: (form, comp) => ({
        visible: vue.showParityOption(form.roundOption)
      }),
      props: {
        caption: 'finish.parityOption',
        required: true,
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('parity')
      }
    },
    extraFabricHeightFormula: {
      type: MDinput,
      defaultValue: null,
      dynamicProps: (form, comp) => ({
        visible: vue.isExtraFabricHeightApplicable()
      }),
      props: {
        maxlength: 255,
        caption: 'finish.extraFabricHeightFormula'
      }
    },
    extraFabricWidthFormula: {
      type: MDinput,
      defaultValue: null,
      dynamicProps: (form, comp) => ({
        visible: vue.isExtraFabricWidthApplicable()
      }),
      props: {
        maxlength: 255,
        caption: 'finish.extraFabricWidthFormula'
      }
    },
    fabricWidthFactor: {
      type: InputNumber,
      defaultValue: null,
      dynamicProps: form => {
        return {
          visible: vue.isFabricWidthFactorRequired()
        };
      },
      props: {
        caption: 'finish.fabricWidthFactor',
        precision: 2,
        step: 0.05
      }
    },
    minimumFabricWidthFactor: {
      type: InputNumber,
      defaultValue: null,
      dynamicProps: form => {
        return {
          visible: vue.isFabricWidthFactorRequired()
        };
      },
      props: {
        caption: 'finish.minimumFabricWidthFactor',
        precision: 2,
        step: 0.05
      }
    },
    maximumFabricWidthFactor: {
      type: InputNumber,
      defaultValue: null,
      dynamicProps: form => {
        return {
          visible: vue.isFabricWidthFactorRequired()
        };
      },
      props: {
        caption: 'finish.maximumFabricWidthFactor',
        precision: 2,
        step: 0.05
      }
    },
    applyPleatMachineCorrectionYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'finish.applyPleatMachineCorrectionYN'
      },
      dynamicProps: form => {
        return {
          visible: vue.isPleats()
        };
      }
    },
    defaultProductID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'finish.defaultProduct',
        loading: vue.products,
        options: vue.$store.getters['product/loadedItems'],
        valueField: 'id',
        labelField: 'description'
      },
      dynamicProps: form => {
        return {
          visible: vue.isProductTypeRequired()
        };
      }
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
